/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Cookies_Analytics_DescInputs */

const en_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product usage analytics, loaded only after your explicit consent. You can withdraw consent at any time via the cookie settings in the footer.`)
};

const de_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktnutzungsanalyse, wird nur nach Ihrer ausdruecklichen Einwilligung geladen. Sie koennen Ihre Einwilligung jederzeit ueber die Cookie-Einstellungen in der Fusszeile widerrufen.`)
};

const fr_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses d'utilisation du produit, chargées uniquement après ton consentement explicite. Tu peux retirer ton consentement à tout moment via les paramètres de cookies en bas de page.`)
};

const es_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis de uso del producto, cargado solo después de tu consentimiento explícito. Puedes retirar el consentimiento en cualquier momento a través de los ajustes de cookies en el pie de página.`)
};

const it_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi sull'utilizzo del prodotto, caricata solo dopo il tuo consenso esplicito. Puoi revocare il consenso in qualsiasi momento tramite le impostazioni dei cookie nel footer.`)
};

const nl_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productgebruiksanalyses, alleen geladen na je uitdrukkelijke toestemming. Je kunt je toestemming op elk moment intrekken via de cookie-instellingen in de footer.`)
};

const pl_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka wykorzystania produktu, ładowana wyłącznie po Twojej wyraźnej zgodzie. Zgodę możesz cofnąć w dowolnym momencie przez ustawienia ciasteczek w stopce.`)
};

const fi_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuotteen käyttöanalytiikka, joka ladataan vasta nimenomaisen suostumuksesi jälkeen. Voit peruuttaa suostumuksen milloin tahansa alatunnisteen evästeasetusten kautta.`)
};

const da_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktbrugsanalyse, indlæses kun efter dit udtrykkelige samtykke. Du kan trække samtykket tilbage når som helst via cookieindstillingerne i sidefoden.`)
};

const sv_privacy_cookies_analytics_desc = /** @type {(inputs: Privacy_Cookies_Analytics_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktanvändningsanalys, laddas bara efter ditt uttryckliga samtycke. Du kan återkalla samtycket när som helst via cookieinställningarna i sidfoten.`)
};

/**
* | output |
* | --- |
* | "Product usage analytics, loaded only after your explicit consent. You can withdraw consent at any time via the cookie settings in the footer." |
*
* @param {Privacy_Cookies_Analytics_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_cookies_analytics_desc = /** @type {((inputs?: Privacy_Cookies_Analytics_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Cookies_Analytics_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_cookies_analytics_desc(inputs)
	if (locale === "fr") return fr_privacy_cookies_analytics_desc(inputs)
	if (locale === "es") return es_privacy_cookies_analytics_desc(inputs)
	if (locale === "it") return it_privacy_cookies_analytics_desc(inputs)
	if (locale === "nl") return nl_privacy_cookies_analytics_desc(inputs)
	if (locale === "pl") return pl_privacy_cookies_analytics_desc(inputs)
	if (locale === "fi") return fi_privacy_cookies_analytics_desc(inputs)
	if (locale === "da") return da_privacy_cookies_analytics_desc(inputs)
	if (locale === "sv") return sv_privacy_cookies_analytics_desc(inputs)
	return en_privacy_cookies_analytics_desc(inputs)
});